import { getLocationSearch } from './getLocationSearch';
export const getLocationSearchList = (target = window) => {
  return getLocationSearch(target).slice(1).split('&').reduce((acc, entry) => {
    const [key, value] = entry.split('=');

    if (key && value) {
      acc.push([key, decodeURIComponent(value)]);
    }

    return acc;
  }, []);
};